import { render, staticRenderFns } from "./CompletedOrders.vue?vue&type=template&id=4fa4e2f6&scoped=true"
import script from "./CompletedOrders.vue?vue&type=script&lang=js"
export * from "./CompletedOrders.vue?vue&type=script&lang=js"
import style0 from "./CompletedOrders.vue?vue&type=style&index=0&id=4fa4e2f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4e2f6",
  null
  
)

export default component.exports